import { useEffect, useState } from 'react'
import { CommonConstant, CreatorsService } from 'utility'

export const GetCreatorsList = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CreatorsService.get(filter)
      setTotal(result.total)
      setData(result.list)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter((prevFilters) => {
      if (typeof key === "object") {
        return { ...prevFilters, ...key };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    refetch,
  }
}

export const GetBlockedCreatorsList = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CreatorsService.getBlockedCreators(filter)
      setTotal(result.total)
      setData(result.list)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter((prevFilters) => {
      if (typeof key === "object") {
        return { ...prevFilters, ...key };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    refetch,
  }
}

export const GetUserFollowersCreatorsList = (id) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CreatorsService.getUserFollowers(id, filter)
      setTotal(result.total)
      setData(result)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter, id])

  const updateFilter = (key, value) => {
    setFilter((prevFilters) => {
      if (typeof key === "object") {
        return { ...prevFilters, ...key };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  const pageChanged = (page) => {
    setFilter((prev) => ({
      ...prev,
      page,
    }))
  }

  const pageSizeChanged = (limit) => {
    setFilter((prev) => ({
      ...prev,
      page: 0,
      limit,
    }))
  }
  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    refetch,
    pageSizeChanged,
  }
}

export const GetUserFollowingCreatorsList = (id) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CreatorsService.getUserFollowing(id, filter)
      setTotal(result.total)
      setData(result)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter, id])

  const updateFilter = (key, value) => {
    setFilter((prevFilters) => {
      if (typeof key === "object") {
        return { ...prevFilters, ...key };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    refetch,
  }
}